<template>
  <div v-if="hasAuth" :style="'display: '+ displayType +';'">
    <slot></slot>
  </div>
  <div v-else-if="elseInfo" style="display: inline-block;">{{elseInfo}}</div>
</template>

<script>
import { getStorage } from '@/utils/index'
export default {
  name: "",
  props: {
    auth: {
      type: String,
      default() {
        return ''
      }
    },
    elseInfo: {
      type: String,
      default() {
        return ''
      }
    },
    displayType: {
      type: String,
      default() {
        return 'inline-block'
      }
    },
  },
  data() {
    return {
      hasAuth: false
    };
  },
  created() {
    this.hasAuth = getStorage('USER_BUTTON_AUTH').indexOf(this.auth) > -1
  },
  methods: {},
};
</script>

<style lang="scss" scoped></style>
